import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '../../../base.component';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { ChartColorService } from '../../../shared/chart-colors.service';
import { ChartLabelService } from '../../../shared/chart-label.service';
import { takeUntil } from 'rxjs/operators';
import { ChartData } from '../../../shared/models/chartData';
import * as moment from 'moment';
import { VisibilityIndexByDate } from '../../models/visibility-index-by-date';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-visibility-index',
  templateUrl: './visibility-index.component.html',
  styleUrl: './visibility-index.component.scss'
})
export class VisibilityIndexComponent extends BaseComponent implements OnInit {

  @Input()
  set visibilityIndexByDate(visibilityIndexByDate: VisibilityIndexByDate) {
    this._chartData = visibilityIndexByDate.visibilityIndexMetrics.hasData ? visibilityIndexByDate.visibilityIndexMetrics : this.disconnectedDataSet;
    this.options.scales.y.max = 100;
    this.score = visibilityIndexByDate.score;
    this.translateLabels(this.chartData);
    this.labels = this.chartData.labels;
    this.datasets = this.chartData.dataSet;
    this.datasets.forEach((dataset, i) => {
      this.data.datasets[i].data = dataset.data;
      this.data.datasets[i].label = dataset.label;
    });
    this.data.labels = this.labels;
  }

  score: number;
  labels;
  datasets: any[];
  chartColors: Array<any>;
  data: ChartConfiguration<'line'>['data'] = {
    labels: [],
    datasets: [
      {
        data: [],
        fill: true,
        tension: 0.4,
      }
    ]
  };
  options: ChartOptions<'line'> = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      tooltip: {
        mode:'index',
        callbacks: {
          label: (tooltipItem) => {
            return `${tooltipItem.dataset.label}: ${tooltipItem.parsed.y}`;
          }
        }
      }
    },
    scales: {
      x: {
        stacked: true
      },
      y: {
        stacked: true,
        min: 0,
        ticks: {
          callback: function (value) {
            return Number.isInteger(value) ? value : '';
          }
        }
      }
    }
  };

  private _chartData: ChartData;
  private disconnectedDataSet = {
    "hasData": false,
    "labelKeys": this.chartLabelService.getPreviousMondays(13),
    "labels": null,
    "dataSet": [
      {
        "label": null,
        "labelKey": "local_listings.label_visibility_index_score",
        "data": []
      }
    ]
  };

  constructor(
    private translate: TranslateService,
    private chartColorService: ChartColorService,
    private chartLabelService: ChartLabelService
  ) {
    super();
  }

  ngOnInit() {
    this.chartColorService.filledLine
      .pipe(
        takeUntil(this.unsubscribe)
      )
      .subscribe((chartColors) => {
        this.chartColors = chartColors;
        this.data.datasets.forEach((x, index) => {
          x.backgroundColor = this.chartColors[index].backgroundColor;
          x.borderColor = this.chartColors[index].borderColor;
          x.borderWidth = this.chartColors[index].borderWidth;
        });
      });
  }

  get chartData(): ChartData {
    return this._chartData;
  }

  private translateLabels(chartData: ChartData) {
    chartData.labels = [];
    for (const i of chartData.labelKeys) {
      chartData.labels.push(moment(i).format('L'));
    }

    for (const i of chartData.dataSet) {
      i.label = this.translate.instant(i.labelKey);
    }
  }
}
